// extracted by mini-css-extract-plugin
export default {"appName":"Apps_appName__Esrmg","title":"Apps_title__G9gVD","package":"Apps_package__LZPsO","icon":"Apps_icon__HsF+m"};